import { ReplicatedLockConfig } from "../../core/game/server/ReplicatedLock";
import { Contact3DStartGame } from "./replicatedActions/Contact3DStartGame";
import { CreateClue } from "./replicatedActions/CreateClue";
import { GuessClueAnswer } from "./replicatedActions/GuessClueAnswer";
import { SetSecretWord } from "./replicatedActions/SetSecretWord";
import { UpdateClueHint } from "./replicatedActions/UpdateClueHint";
import { Clue } from "./replicatedObjects/Clue";
import { Contact3DPlayerRecords } from "./replicatedObjects/Contact3DPlayerRecords";
import { GameState } from "./replicatedObjects/GameState";
import { AnswerResultTimeoutConfig } from "./replicatedTimeouts/AnswerResultTimeout";
import { CommitAnswerTimeoutConfig } from "./replicatedTimeouts/CommitAnswerTimeout";
import { DeleteClueTimeoutConfig } from "./replicatedTimeouts/DeleteClueTimeout";
export const contact3DReplicatedObjects = [
    Contact3DPlayerRecords,
    Clue,
    GameState,
];
export const contact3DReplicatedActions = [
    Contact3DStartGame,
    CreateClue,
    GuessClueAnswer,
    SetSecretWord,
    UpdateClueHint,
];
export const contact3DReplicatedTimeoutConfigs = [
    ReplicatedLockConfig,
    AnswerResultTimeoutConfig,
    CommitAnswerTimeoutConfig,
    DeleteClueTimeoutConfig,
];
//# sourceMappingURL=Contact3DTypes.js.map